module.exports = __webpack_public_path__ + "fonts/OpenSans-SemiBold.a005f4ed.woff";